export default __webpack_public_path__ + "dbbc85b45d083309eecc22a333be601c.svg";